import { Skeleton } from "@/components/ui/skeleton";
import { BotCard } from "./BotCard";
import type { BotSummary } from "@/types/bot";

interface BotListProps {
  bots: BotSummary[];
  isLoading?: boolean;
  onBotSelect: (botId: string) => void;
}

export function BotList({
  bots,
  isLoading = false,
  onBotSelect,
}: BotListProps) {
  if (isLoading) {
    return <BotListSkeleton />;
  }

  if (bots.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No bots available at the moment.
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4"
      data-testid="bot-list-container"
    >
      {bots.map((bot) => (
        <BotCard
          key={bot.id}
          bot={bot}
          onClick={onBotSelect}
        />
      ))}
    </div>
  );
}

function BotListSkeleton() {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Skeleton key={i} className="min-h-[180px] w-full rounded-xl md:min-h-[240px]" />
      ))}
    </div>
  );
}
